var util = require("../util"),
    win = "object" == typeof window ? window : {},
    xmlHttp = win.__oXMLHttpRequest_ || win.XMLHttpRequest;

xmlHttp = "function" == typeof xmlHttp ? xmlHttp : undefined, module.exports = function (t, e) {
  try {
    var n = new xmlHttp();
    n.open("POST", e, !0), n.setRequestHeader("Content-Type", "text/plain"), n.send(JSON.stringify(t));
  } catch (i) {
    util.warn("[retcode] Failed to log, exception is :\n" + i);
  }
};